// Test IDs for the Protego.ai $97 POA landing page funnel.
// Keys camelCase, values kebab-case `<feature>-<element>`.

export const LANDING = {
    // Urgency bar
    urgencyBar: 'urgency-bar',
    urgencyCountdown: 'urgency-countdown',

    // Hero
    hero: 'hero-section',
    heroHeadline: 'hero-headline',
    heroCta: 'hero-cta-button',
    heroVsl: 'hero-vsl-placeholder',
    heroVslPlay: 'hero-vsl-play',

    // Pain
    pain: 'pain-section',

    // Attorney Trap comparison
    trap: 'attorney-trap-section',
    trapCta: 'attorney-trap-cta',
    trapCardAttorney: 'trap-card-attorney',
    trapCardAgency: 'trap-card-agency',
    trapCardProtego: 'trap-card-protego',

    // Five mistakes
    mistakes: 'five-mistakes-section',
    mistakesCta: 'five-mistakes-cta',

    // Savings calculator
    savings: 'savings-calculator-section',
    savingsCta: 'savings-cta',

    // How it works
    howItWorks: 'how-it-works-section',
    howCta: 'how-it-works-cta',

    // Founder
    founder: 'founder-section',

    // Who is this for
    personas: 'personas-section',
    personasCta: 'personas-cta',

    // Offer stack
    offer: 'offer-stack-section',
    offerCta: 'offer-stack-cta',

    // Testimonials
    testimonials: 'testimonials-section',

    // Guarantee
    guarantee: 'guarantee-section',

    // FAQ
    faq: 'faq-section',
    faqItem: (idx) => `faq-item-${idx}`,

    // Final CTA
    finalCta: 'final-cta-section',
    finalCtaButton: 'final-cta-button',

    // Footer
    footer: 'landing-footer',
};
